export const POINTS = [
  {
    id: 1,
    title: 'Возьмём всё на себя',
    description:
      'До, во время и после сделки — найдём арендаторов, поможем с документами, останемся на связи на всём сроке аренды, а потом подберём новых жильцов.',
  },
  {
    id: 2,
    title: 'Проверим арендатора',
    description: 'На отсутствие административных и уголовных правонарушений, а также платёжеспособность.',
  },
  {
    id: 3,
    title: 'Сдадим быстро',
    description:
      'Подготовим квартиру, сделаем фотографии и настроим рекламу объявления. Показы проведём самостоятельно и в любое время.',
  },
  {
    id: 4,
    title: 'Застрахуем имущество',
    description: 'Составим опись и проверим всё на сохранность. Если что-то сломается — компенсируем ущерб.',
  },
  {
    id: 5,
    title: 'Проконтролируем оплату',
    description: 'Если жильцы съедут и не заплатят, компенсируем месячную аренду и до 2 недель простоя квартиры.',
  },
];
